import { createActions, createReducer } from "reduxsauce";
import { onChangeFieldValue } from "utils/functions";
import { defaultState } from "./tags-model";

export const tagsShowLoading = (state) => ({
  ...state,
  isLoading: true,
});

export const tagsHideLoading = (state) => ({
  ...state,
  isLoading: false,
});

export const showLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: true,
});

export const hideLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: false,
});

export const showLoadingImportCsvModal = (state = defaultState) => ({
  ...state,
  isLoadingImportCsvModal: true,
});

export const hideLoadingImportCsvModal = (state = defaultState) => ({
  ...state,
  isLoadingImportCsvModal: false,
});

export const changeFieldValue = (state, { fieldName, value }) => ({
  ...state,
  filter: onChangeFieldValue(state.filter, fieldName, value),
});

export const updateFilter = (state, action: any) => {
  return {
    ...state,
    searchFilter: action.filter,
  };
};

export const fetchTags = (state, { items, totalItems }) => ({
  ...state,
  isLoadingTable: false,
  items,
  totalItems,
});

export const importDataCsv = (state, { dataCsv }) => ({
  ...state,
  dataCsv,
});

export const updateResultDataCsv = (state, { resultCsvData }) => ({
  ...state,
  resultCsvData,
});

export const showLoadingEditDrawer = (state = defaultState) => ({
  ...state,
  isLoadingEditDrawer: true,
});

export const hideLoadingEditDrawer = (state = defaultState) => ({
  ...state,
  isLoadingEditDrawer: false,
});

export const showImportCsvModal = (state = defaultState) => ({
  ...state,
  visibleImportCsvModal: true,
});

export const hideImportCsvModal = (state = defaultState) => ({
  ...state,
  visibleImportCsvModal: false,
  resultCsvData: null,
  dataCsv: null,
});

export const showDrawerTags = (state = defaultState) => ({
  ...state,
  visibleDrawer: true,
});

export const hideDrawerTags = (state = defaultState) => ({
  ...state,
  visibleDrawer: false,
  vehicleAlreadyHasTagUserAccepted: false,
  tagHasInactiveUserAccepted: false,
  tagWasInactive: false,
  initialTagActiveState: false,
  vehicleTagInfo: {
    ...defaultState.vehicleTagInfo,
  },
});

export const updateEventTagActive = (state, action: any) => ({
  ...state,
  editTag: {
    ...state.editTag,
    isTagActive: action.isTagActive,
  },
});

export const updateDataTag = (state, action: any) => ({
  ...state,
  editTag: {
    ...state.editTag,
    ...action.editTag,
  },
  initialTagActiveState: action.editTag?.isTagActive ?? state.initialTagActiveState,
});

export const updateVehicleTagInfo = (state, action: any) => ({
  ...state,
  vehicleTagInfo: {
    ...state.vehicleTagInfo,
    ...action.vehicleTagInfo,
  },
});

export const updateTagInactive = (state, action: any) => ({
  ...state,
  tagWasInactive: action.tagWasInactive,
});

export const updateVehicleAlreadyHasTagUserAccepted = (state, action: any) => ({
  ...state,
  vehicleAlreadyHasTagUserAccepted: action.vehicleAlreadyHasTagUserAccepted,
});

export const updateTagHasInactiveUserAccepted = (state, action: any) => ({
  ...state,
  tagHasInactiveUserAccepted: action.tagHasInactiveUserAccepted,
});

export const { Types, Creators } = createActions({
  tagsShowLoading: [],
  tagsHideLoading: [],
  tagsShowDrawer: [],
  tagsHideDrawer: [],
  tagsShowLoadingTable: [],
  tagsHideLoadingTable: [],
  tagsShowLoadingEditDrawer: [],
  tagsHideLoadingEditDrawer: [],
  tagsUpdateFilter: ["filter"],
  tagsUpdateVehicleTagInfo: ["vehicleTagInfo"],
  tagsChangeFieldValue: ["fieldName", "value"],
  tagsFetchRegister: ["items", "totalItems"],
  tagsUpdateImportCsvData: ["dataCsv"],
  tagsUpdateResultCsvData: ["resultCsvData"],
  tagsShowImportCsvModal: [],
  tagsHideImportCsvModal: [],
  tagsShowLoadingImportCsvModal: [],
  tagsHideLoadingImportCsvModal: [],
  tagsEventTagActive: ["isTagActive"],
  tagsUpdateTagInactive: ["tagWasInactive"],
  tagsDataTag: ["editTag"],
  tagsUpdateVehicleAlreadyHasTagUserAccepted: ["vehicleAlreadyHasTagUserAccepted"],
  tagsUpdateTagHasInactiveUserAccepted: ["tagHasInactiveUserAccepted"],
  tagsFetchByIdAsync: ["id"],
  tagsUpdateTagAsync: ["tag"],
  tagsRegisterFetchAsync: [],
  tagsImportCsvAsync: ["data"],
});

export default createReducer(defaultState, {
  [Types.TAGS_SHOW_LOADING]: tagsShowLoading,
  [Types.TAGS_HIDE_LOADING]: tagsHideLoading,
  [Types.TAGS_HIDE_DRAWER]: hideDrawerTags,
  [Types.TAGS_SHOW_DRAWER]: showDrawerTags,
  [Types.TAGS_SHOW_LOADING_TABLE]: showLoadingTable,
  [Types.TAGS_HIDE_LOADING_TABLE]: hideLoadingTable,
  [Types.TAGS_SHOW_LOADING_EDIT_DRAWER]: showLoadingEditDrawer,
  [Types.TAGS_HIDE_LOADING_EDIT_DRAWER]: hideLoadingEditDrawer,
  [Types.TAGS_UPDATE_IMPORT_CSV_DATA]: importDataCsv,
  [Types.TAGS_HIDE_LOADING_IMPORT_CSV_MODAL]: hideLoadingImportCsvModal,
  [Types.TAGS_SHOW_LOADING_IMPORT_CSV_MODAL]: showLoadingImportCsvModal,
  [Types.TAGS_UPDATE_VEHICLE_TAG_INFO]: updateVehicleTagInfo,
  [Types.TAGS_SHOW_IMPORT_CSV_MODAL]: showImportCsvModal,
  [Types.TAGS_UPDATE_RESULT_CSV_DATA]: updateResultDataCsv,
  [Types.TAGS_HIDE_IMPORT_CSV_MODAL]: hideImportCsvModal,
  [Types.TAGS_UPDATE_TAG_INACTIVE]: updateTagInactive,
  [Types.TAGS_CHANGE_FIELD_VALUE]: changeFieldValue,
  [Types.TAGS_UPDATE_FILTER]: updateFilter,
  [Types.TAGS_FETCH_REGISTER]: fetchTags,
  [Types.TAGS_EVENT_TAG_ACTIVE]: updateEventTagActive,
  [Types.TAGS_DATA_TAG]: updateDataTag,
  [Types.TAGS_UPDATE_VEHICLE_ALREADY_HAS_TAG_USER_ACCEPTED]: updateVehicleAlreadyHasTagUserAccepted,
  [Types.TAGS_UPDATE_TAG_HAS_INACTIVE_USER_ACCEPTED]: updateTagHasInactiveUserAccepted,
});
